import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useState, useMemo, useRef, useContext, useEffect, useReducer, useLayoutEffect } from 'react';
import ReactDOM, { unstable_batchedUpdates } from 'react-dom';
var menuContainerClass = 'rc-menu-container';
var menuClass = 'rc-menu';
var menuButtonClass = 'rc-menu-button';
var menuArrowClass = 'arrow';
var menuItemClass = 'item';
var menuDividerClass = 'divider';
var menuHeaderClass = 'header';
var menuGroupClass = 'group';
var subMenuClass = 'submenu';
var radioGroupClass = 'radio-group';
var initialHoverIndex = -1;
var MenuListItemContext = /*#__PURE__*/React.createContext({});
var MenuListContext = /*#__PURE__*/React.createContext({});
var EventHandlersContext = /*#__PURE__*/React.createContext({});
var RadioGroupContext = /*#__PURE__*/React.createContext({});
var SettingsContext = /*#__PURE__*/React.createContext({});
var ItemSettingsContext = /*#__PURE__*/React.createContext({});
var Keys = Object.freeze({
  'ENTER': 'Enter',
  'ESC': 'Escape',
  'SPACE': ' ',
  'HOME': 'Home',
  'END': 'End',
  'LEFT': 'ArrowLeft',
  'RIGHT': 'ArrowRight',
  'UP': 'ArrowUp',
  'DOWN': 'ArrowDown'
});
var HoverIndexActionTypes = Object.freeze({
  'RESET': 'HOVER_INDEX_RESET',
  'SET': 'HOVER_INDEX_SET',
  'UNSET': 'HOVER_INDEX_UNSET',
  'INCREASE': 'HOVER_INDEX_INCREASE',
  'DECREASE': 'HOVER_INDEX_DECREASE',
  'FIRST': 'HOVER_INDEX_FIRST',
  'LAST': 'HOVER_INDEX_LAST'
});
var SubmenuActionTypes = Object.freeze({
  'OPEN': 'SUBMENU_OPEN',
  'CLOSE': 'SUBMENU_CLOSE'
});
var CloseReason = Object.freeze({
  'CLICK': 'click',
  'CANCEL': 'cancel',
  'BLUR': 'blur',
  'SCROLL': 'scroll'
});

var batchedUpdates = unstable_batchedUpdates || function (callback) {
  return callback();
};

var defineName = function defineName(component, name) {
  return name ? Object.defineProperty(component, '_reactMenu', {
    value: name,
    writable: false
  }) : component;
};

var getName = function getName(component) {
  return component && component['_reactMenu'];
};

var applyHOC = function applyHOC(HOC) {
  return function () {
    return defineName(HOC.apply(void 0, arguments), getName(arguments.length <= 0 ? undefined : arguments[0]));
  };
};

var applyStatics = function applyStatics(sourceComponent) {
  return function (wrappedComponent) {
    return defineName(wrappedComponent, getName(sourceComponent));
  };
};

var safeCall = function safeCall(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof fn === 'function' ? fn.apply(void 0, args) : fn;
};

var attachHandlerProps = function attachHandlerProps(handlers, props) {
  var result = {};

  var _loop = function _loop() {
    var handlerName = _Object$keys[_i];
    var handler = handlers[handlerName];
    var propHandler = props[handlerName];
    var attachedHandler = void 0;

    if (typeof propHandler === 'function') {
      attachedHandler = function attachedHandler(e) {
        propHandler(e);
        handler(e);
      };
    } else {
      attachedHandler = handler;
    }

    result[handlerName] = attachedHandler;
  };

  for (var _i = 0, _Object$keys = Object.keys(handlers); _i < _Object$keys.length; _i++) {
    _loop();
  }

  return result;
};

var parsePadding = function parsePadding(paddingStr) {
  if (typeof paddingStr !== 'string') return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  var padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
  var top = !isNaN(padding[0]) ? padding[0] : 0;
  var right = !isNaN(padding[1]) ? padding[1] : top;
  return {
    top: top,
    right: right,
    bottom: !isNaN(padding[2]) ? padding[2] : top,
    left: !isNaN(padding[3]) ? padding[3] : right
  };
};

var bem = function bem(block, element) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (userClassName, userModifiers) {
    var blockElement = element ? "".concat(block, "__").concat(element) : block;
    var className = blockElement;

    for (var _i2 = 0, _Object$keys2 = Object.keys(modifiers); _i2 < _Object$keys2.length; _i2++) {
      var name = _Object$keys2[_i2];
      var value = modifiers[name];

      if (value) {
        className += " ".concat(blockElement, "--");
        className += value === true ? name : "".concat(name, "-").concat(value);
      }
    }

    if (typeof userClassName === 'function') {
      userClassName = userClassName(userModifiers || modifiers);
    }

    if (typeof userClassName === 'string') {
      userClassName = userClassName.trim();
      if (userClassName) className += " ".concat(userClassName);
    }

    return className;
  };
};

var isObject = function isObject(obj) {
  return obj && typeof obj === 'object';
};

var sanitiseKey = function sanitiseKey(key) {
  return key.charAt(0) === '$' ? key.slice(1) : key;
};

var flatStyles = function flatStyles(styles, modifiers) {
  if (typeof styles === 'function') return styles(modifiers);
  if (!isObject(styles)) return undefined;
  if (!modifiers) return styles;
  var style = {};

  for (var _i3 = 0, _Object$keys3 = Object.keys(styles); _i3 < _Object$keys3.length; _i3++) {
    var prop = _Object$keys3[_i3];
    var value = styles[prop];

    if (isObject(value)) {
      var modifierValue = modifiers[sanitiseKey(prop)];

      if (typeof modifierValue === 'string') {
        for (var _i4 = 0, _Object$keys4 = Object.keys(value); _i4 < _Object$keys4.length; _i4++) {
          var nestedProp = _Object$keys4[_i4];
          var nestedValue = value[nestedProp];

          if (isObject(nestedValue)) {
            if (sanitiseKey(nestedProp) === modifierValue) {
              Object.assign(style, nestedValue);
            }
          } else {
            style[nestedProp] = nestedValue;
          }
        }
      } else if (modifierValue) {
        Object.assign(style, value);
      }
    } else {
      style[prop] = value;
    }
  }

  return style;
};

var getScrollAncestor = function getScrollAncestor(node) {
  while (node && node !== document.body) {
    var _getComputedStyle = getComputedStyle(node),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    node = node.parentNode;
  }

  return window;
};

var floatEqual = function floatEqual(a, b) {
  var diff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.0001;
  return Math.abs(a - b) < diff;
};

var isProd = process.env.NODE_ENV === 'production';

var validateChildren = function validateChildren(parent, child, permitted) {
  if (!child) return false;

  if (!permitted.includes(getName(child.type))) {
    !isProd && console.warn("[react-menu] ".concat(child.type || child, " is ignored.\n"), "The permitted children inside a ".concat(parent, " are ").concat(permitted.join(', '), "."), 'If you create HOC of these components, you can use the applyHOC or applyStatics helper, see more at: https://szhsin.github.io/react-menu/docs#utils-apply-hoc');
    return false;
  }

  return true;
};

var cloneChildren = function cloneChildren(children) {
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var index = startIndex;
  var descendOverflow = false;
  var permittedChildren = ['MenuDivider', 'MenuGroup', 'MenuHeader', 'MenuItem', 'FocusableItem', 'MenuRadioGroup', 'SubMenu'];
  var items = React.Children.map(children, function (child) {
    if (!validateChildren('Menu or SubMenu', child, permittedChildren)) return null;

    switch (getName(child.type)) {
      case 'MenuDivider':
      case 'MenuHeader':
        return child;

      case 'MenuRadioGroup':
        {
          var _permittedChildren = ['MenuItem'];
          var props = {
            type: 'radio'
          };
          var radioItems = React.Children.map(child.props.children, function (radioChild) {
            if (!validateChildren('MenuRadioGroup', radioChild, _permittedChildren)) return null;
            return radioChild.props.disabled ? /*#__PURE__*/React.cloneElement(radioChild, props) : /*#__PURE__*/React.cloneElement(radioChild, _objectSpread(_objectSpread({}, props), {}, {
              index: index++
            }));
          });
          return /*#__PURE__*/React.cloneElement(child, {
            children: radioItems
          });
        }

      case 'MenuGroup':
        {
          var _cloneChildren = cloneChildren(child.props.children, index),
              _items = _cloneChildren.items,
              endIndex = _cloneChildren.endIndex,
              descOverflow = _cloneChildren.descendOverflow;

          index = endIndex;
          var takeOverflow = Boolean(child.props.takeOverflow);
          if (!isProd && (descendOverflow === descOverflow ? descOverflow : takeOverflow)) throw new Error('[react-menu] Only one MenuGroup in a menu is allowed to have takeOverflow prop.');
          descendOverflow = descendOverflow || descOverflow || takeOverflow;
          return /*#__PURE__*/React.cloneElement(child, {
            children: _items
          });
        }

      default:
        return child.props.disabled ? child : /*#__PURE__*/React.cloneElement(child, {
          index: index++
        });
    }
  });
  return {
    items: items,
    endIndex: index,
    descendOverflow: descendOverflow
  };
};

var sharedMenuDefaultProp = {
  offsetX: 0,
  offsetY: 0,
  align: 'start',
  direction: 'bottom',
  position: 'auto',
  overflow: 'visible'
};

var menuDefaultPropsBase = _objectSpread(_objectSpread({}, sharedMenuDefaultProp), {}, {
  animation: true,
  reposition: 'auto',
  viewScroll: 'initial',
  submenuOpenDelay: 300,
  submenuCloseDelay: 150
});

var useActiveState = function useActiveState(isHovering, isDisabled, customKey) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var activeKeys = useMemo(function () {
    return [Keys.SPACE, Keys.ENTER].concat(_toConsumableArray(customKey ? [customKey] : []));
  }, [customKey]);
  var cancelActive = useCallback(function () {
    return setActive(false);
  }, []);
  return {
    isActive: active,
    onPointerDown: useCallback(function () {
      if (!isDisabled) setActive(true);
    }, [isDisabled]),
    onPointerUp: cancelActive,
    onPointerLeave: cancelActive,
    onKeyDown: useCallback(function (e) {
      if (isHovering && !isDisabled && activeKeys.includes(e.key)) {
        setActive(true);
      }
    }, [isHovering, isDisabled, activeKeys]),
    onKeyUp: useCallback(function (e) {
      if (activeKeys.includes(e.key)) {
        setActive(false);
      }
    }, [activeKeys]),
    onBlur: useCallback(function (e) {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setActive(false);
      }
    }, [])
  };
};

var useItemState = function useItemState(isDisabled, index) {
  var ref = useRef(null);

  var _useContext = useContext(ItemSettingsContext),
      submenuCloseDelay = _useContext.submenuCloseDelay;

  var _useContext2 = useContext(MenuListItemContext),
      isParentOpen = _useContext2.isParentOpen,
      hoverIndex = _useContext2.hoverIndex,
      isSubmenuOpen = _useContext2.isSubmenuOpen,
      dispatch = _useContext2.dispatch;

  var isHovering = hoverIndex === index;
  var timeoutId = useRef();
  var setHover = useCallback(function () {
    if (!isDisabled) dispatch({
      type: HoverIndexActionTypes.SET,
      index: index
    });
  }, [isDisabled, dispatch, index]);
  var onBlur = useCallback(function (e) {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      dispatch({
        type: HoverIndexActionTypes.UNSET,
        index: index
      });
    }
  }, [dispatch, index]);
  var onMouseEnter = useCallback(function () {
    if (isSubmenuOpen) {
      timeoutId.current = setTimeout(setHover, submenuCloseDelay);
    } else {
      setHover();
    }
  }, [isSubmenuOpen, submenuCloseDelay, setHover]);
  var onMouseLeave = useCallback(function (_, keepHover) {
    timeoutId.current && clearTimeout(timeoutId.current);
    if (!keepHover) dispatch({
      type: HoverIndexActionTypes.UNSET,
      index: index
    });
  }, [dispatch, index]);
  useEffect(function () {
    return function () {
      return clearTimeout(timeoutId.current);
    };
  }, []);
  useEffect(function () {
    if (isHovering && isParentOpen) {
      ref.current && ref.current.focus();
    }
  }, [isHovering, isParentOpen]);
  return {
    ref: ref,
    isHovering: isHovering,
    setHover: setHover,
    onBlur: onBlur,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
};

var useMenuChange = function useMenuChange(onChange, isOpen) {
  var prevOpen = useRef(isOpen);
  useEffect(function () {
    if (prevOpen.current !== isOpen) safeCall(onChange, {
      open: isOpen
    });
    prevOpen.current = isOpen;
  }, [onChange, isOpen]);
};

var FocusPositions = Object.freeze({
  'INITIAL': 'initial',
  'FIRST': 'first',
  'LAST': 'last'
});
var MenuStates = Object.freeze({
  'UNMOUNTED': 0,
  'CLOSED': 1,
  'OPEN': 2
});
var MenuStateActionType = Object.freeze({
  'OPEN': 0,
  'CLOSE': 1,
  'TOGGLE': 2
});

var useMenuState = function useMenuState() {
  var keepMounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _useState3 = useState({
    position: FocusPositions.INITIAL
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      menuItemFocus = _useState4[0],
      setMenuItemFocus = _useState4[1];

  var _useReducer = useReducer(menuStateReducer, MenuStates.UNMOUNTED),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      menuState = _useReducer2[0],
      dispatch = _useReducer2[1];

  function menuStateReducer(state, _ref) {
    var type = _ref.type;

    switch (type) {
      case MenuStateActionType.OPEN:
        return MenuStates.OPEN;

      case MenuStateActionType.CLOSE:
        if (state === MenuStates.OPEN) {
          return keepMounted ? MenuStates.CLOSED : MenuStates.UNMOUNTED;
        } else {
          return state;
        }

      case MenuStateActionType.TOGGLE:
        if (state === MenuStates.OPEN) {
          return keepMounted ? MenuStates.CLOSED : MenuStates.UNMOUNTED;
        } else {
          return MenuStates.OPEN;
        }

      default:
        throw new Error('menuStateReducer: unknown action type');
    }
  }

  return {
    isMounted: menuState !== MenuStates.UNMOUNTED,
    isOpen: menuState === MenuStates.OPEN,
    menuItemFocus: menuItemFocus,
    openMenu: useCallback(function () {
      var menuItemFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FocusPositions.INITIAL;
      setMenuItemFocus({
        position: menuItemFocus
      });
      dispatch({
        type: MenuStateActionType.OPEN
      });
    }, []),
    closeMenu: useCallback(function () {
      return dispatch({
        type: MenuStateActionType.CLOSE
      });
    }, []),
    toggleMenu: useCallback(function () {
      var menuItemFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FocusPositions.INITIAL;
      setMenuItemFocus({
        position: menuItemFocus
      });
      dispatch({
        type: MenuStateActionType.TOGGLE
      });
    }, [])
  };
};

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
var MenuButton = defineName( /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function MenuButton(_ref2, ref) {
  var className = _ref2.className,
      styles = _ref2.styles,
      isOpen = _ref2.isOpen,
      disabled = _ref2.disabled,
      children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, ["className", "styles", "isOpen", "disabled", "children"]);

  var modifiers = Object.freeze({
    open: isOpen
  });
  return /*#__PURE__*/React.createElement("button", Object.assign({
    "aria-haspopup": "true",
    "aria-expanded": isOpen,
    "aria-disabled": disabled || undefined,
    disabled: disabled
  }, restProps, {
    ref: ref,
    className: bem(menuButtonClass, null, modifiers)(className),
    style: flatStyles(styles, modifiers)
  }), children);
})), 'MenuButton');
var MenuList = defineName( /*#__PURE__*/React.memo(function MenuList(_ref3) {
  var ariaLabel = _ref3.ariaLabel,
      className = _ref3.className,
      styles = _ref3.styles,
      arrowClassName = _ref3.arrowClassName,
      arrowStyles = _ref3.arrowStyles,
      anchorPoint = _ref3.anchorPoint,
      anchorRef = _ref3.anchorRef,
      containerRef = _ref3.containerRef,
      arrow = _ref3.arrow,
      align = _ref3.align,
      direction = _ref3.direction,
      position = _ref3.position,
      overflow = _ref3.overflow,
      repositionFlag = _ref3.repositionFlag,
      _ref3$captureFocus = _ref3.captureFocus,
      captureFocus = _ref3$captureFocus === void 0 ? true : _ref3$captureFocus,
      isOpen = _ref3.isOpen,
      isDisabled = _ref3.isDisabled,
      menuItemFocus = _ref3.menuItemFocus,
      offsetX = _ref3.offsetX,
      offsetY = _ref3.offsetY,
      children = _ref3.children,
      onClose = _ref3.onClose,
      restProps = _objectWithoutProperties(_ref3, ["ariaLabel", "className", "styles", "arrowClassName", "arrowStyles", "anchorPoint", "anchorRef", "containerRef", "arrow", "align", "direction", "position", "overflow", "repositionFlag", "captureFocus", "isOpen", "isDisabled", "menuItemFocus", "offsetX", "offsetY", "children", "onClose"]);

  var _useState5 = useState({
    x: 0,
    y: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      menuPosition = _useState6[0],
      setMenuPosition = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      arrowPosition = _useState8[0],
      setArrowPosition = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      overflowData = _useState10[0],
      setOverflowData = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isClosing = _useState12[0],
      setClosing = _useState12[1];

  var _useState13 = useState(direction),
      _useState14 = _slicedToArray(_useState13, 2),
      expandedDirection = _useState14[0],
      setExpandedDirection = _useState14[1];

  var _useContext3 = useContext(SettingsContext),
      animation = _useContext3.animation,
      boundingBoxRef = _useContext3.boundingBoxRef,
      boundingBoxPadding = _useContext3.boundingBoxPadding,
      rootMenuRef = _useContext3.rootMenuRef,
      rootAnchorRef = _useContext3.rootAnchorRef,
      scrollingRef = _useContext3.scrollingRef,
      anchorScrollingRef = _useContext3.anchorScrollingRef,
      reposition = _useContext3.reposition,
      viewScroll = _useContext3.viewScroll;

  var menuRef = useRef(null);
  var arrowRef = useRef(null);
  var menuItemsCount = useRef(0);
  var latestOpen = useRef(isOpen);
  var latestMenuSize = useRef({
    width: 0,
    height: 0
  });
  var latestHandlePosition = useRef(function () {});
  var descendOverflowRef = useRef(false);
  var reposFlag = useContext(MenuListContext).reposSubmenu || repositionFlag;

  var _useReducer3 = useReducer(function (c) {
    return c + 1;
  }, 1),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      reposSubmenu = _useReducer4[0],
      forceReposSubmenu = _useReducer4[1];

  var _useReducer5 = useReducer(reducer, {
    hoverIndex: initialHoverIndex,
    openSubmenuCount: 0
  }),
      _useReducer6 = _slicedToArray(_useReducer5, 2),
      _useReducer6$ = _useReducer6[0],
      hoverIndex = _useReducer6$.hoverIndex,
      openSubmenuCount = _useReducer6$.openSubmenuCount,
      dispatch = _useReducer6[1];

  function reducer(_ref4, action) {
    var hoverIndex = _ref4.hoverIndex,
        openSubmenuCount = _ref4.openSubmenuCount;
    return {
      hoverIndex: hoverIndexReducer(hoverIndex, action),
      openSubmenuCount: submenuCountReducer(openSubmenuCount, action)
    };
  }

  function hoverIndexReducer(state, _ref5) {
    var type = _ref5.type,
        index = _ref5.index;

    switch (type) {
      case HoverIndexActionTypes.RESET:
        return initialHoverIndex;

      case HoverIndexActionTypes.SET:
        return index;

      case HoverIndexActionTypes.UNSET:
        return state === index ? initialHoverIndex : state;

      case HoverIndexActionTypes.DECREASE:
        {
          var i = state;
          i--;
          if (i < 0) i = menuItemsCount.current - 1;
          return i;
        }

      case HoverIndexActionTypes.INCREASE:
        {
          var _i5 = state;
          _i5++;
          if (_i5 >= menuItemsCount.current) _i5 = 0;
          return _i5;
        }

      case HoverIndexActionTypes.FIRST:
        return menuItemsCount.current > 0 ? 0 : initialHoverIndex;

      case HoverIndexActionTypes.LAST:
        return menuItemsCount.current > 0 ? menuItemsCount.current - 1 : initialHoverIndex;

      default:
        return state;
    }
  }

  var menuItems = useMemo(function () {
    var _cloneChildren2 = cloneChildren(children),
        items = _cloneChildren2.items,
        endIndex = _cloneChildren2.endIndex,
        descendOverflow = _cloneChildren2.descendOverflow;

    menuItemsCount.current = endIndex;
    descendOverflowRef.current = descendOverflow;
    return items;
  }, [children]);

  var handleKeyDown = function handleKeyDown(e) {
    var handled = false;

    switch (e.key) {
      case Keys.HOME:
        dispatch({
          type: HoverIndexActionTypes.FIRST
        });
        handled = true;
        break;

      case Keys.END:
        dispatch({
          type: HoverIndexActionTypes.LAST
        });
        handled = true;
        break;

      case Keys.UP:
        dispatch({
          type: HoverIndexActionTypes.DECREASE
        });
        handled = true;
        break;

      case Keys.DOWN:
        dispatch({
          type: HoverIndexActionTypes.INCREASE
        });
        handled = true;
        break;

      case Keys.SPACE:
        if (e.target && e.target.className.includes(menuClass)) {
          e.preventDefault();
        }

        break;
    }

    if (handled) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var handleAnimationEnd = function handleAnimationEnd() {
    if (isClosing) {
      setClosing(false);
      setOverflowData();
    }
  };

  var positionHelpers = useCallback(function () {
    var menuRect = menuRef.current.getBoundingClientRect();
    var containerRect = containerRef.current.getBoundingClientRect();
    var boundingRect = scrollingRef.current === window ? {
      left: 0,
      top: 0,
      right: document.documentElement.clientWidth,
      bottom: window.innerHeight
    } : scrollingRef.current.getBoundingClientRect();
    var padding = parsePadding(boundingBoxPadding);

    var getLeftOverflow = function getLeftOverflow(x) {
      return x + containerRect.left - boundingRect.left - padding.left;
    };

    var getRightOverflow = function getRightOverflow(x) {
      return x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    };

    var getTopOverflow = function getTopOverflow(y) {
      return y + containerRect.top - boundingRect.top - padding.top;
    };

    var getBottomOverflow = function getBottomOverflow(y) {
      return y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    };

    var confineHorizontally = function confineHorizontally(x) {
      var leftOverflow = getLeftOverflow(x);

      if (leftOverflow < 0) {
        x -= leftOverflow;
      } else {
        var rightOverflow = getRightOverflow(x);

        if (rightOverflow > 0) {
          x -= rightOverflow;
          leftOverflow = getLeftOverflow(x);
          if (leftOverflow < 0) x -= leftOverflow;
        }
      }

      return x;
    };

    var confineVertically = function confineVertically(y) {
      var topOverflow = getTopOverflow(y);

      if (topOverflow < 0) {
        y -= topOverflow;
      } else {
        var bottomOverflow = getBottomOverflow(y);

        if (bottomOverflow > 0) {
          y -= bottomOverflow;
          topOverflow = getTopOverflow(y);
          if (topOverflow < 0) y -= topOverflow;
        }
      }

      return y;
    };

    return {
      menuRect: menuRect,
      containerRect: containerRect,
      getLeftOverflow: getLeftOverflow,
      getRightOverflow: getRightOverflow,
      getTopOverflow: getTopOverflow,
      getBottomOverflow: getBottomOverflow,
      confineHorizontally: confineHorizontally,
      confineVertically: confineVertically
    };
  }, [containerRef, scrollingRef, boundingBoxPadding]);
  var placeArrowX = useCallback(function (menuX, anchorRect, containerRect, menuRect) {
    var x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    var offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
  }, []);
  var placeArrowY = useCallback(function (menuY, anchorRect, containerRect, menuRect) {
    var y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    var offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
  }, []);
  var placeLeftorRight = useCallback(function (_ref6, _ref7, _ref8) {
    var anchorRect = _ref6.anchorRect,
        containerRect = _ref6.containerRect,
        menuRect = _ref6.menuRect;
    var placeLeftorRightY = _ref7.placeLeftorRightY,
        placeLeftX = _ref7.placeLeftX,
        placeRightX = _ref7.placeRightX;
    var getLeftOverflow = _ref8.getLeftOverflow,
        getRightOverflow = _ref8.getRightOverflow,
        confineHorizontally = _ref8.confineHorizontally,
        confineVertically = _ref8.confineVertically;
    var computedDirection = direction;
    var y = placeLeftorRightY;

    if (position !== 'initial') {
      y = confineVertically(y);

      if (position === 'anchor') {
        y = Math.min(y, anchorRect.bottom - containerRect.top);
        y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
      }
    }

    var x, leftOverflow, rightOverflow;

    if (computedDirection === 'left') {
      x = placeLeftX;

      if (position !== 'initial') {
        leftOverflow = getLeftOverflow(x);

        if (leftOverflow < 0) {
          rightOverflow = getRightOverflow(placeRightX);

          if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
            x = placeRightX;
            computedDirection = 'right';
          }
        }
      }
    } else {
      x = placeRightX;

      if (position !== 'initial') {
        rightOverflow = getRightOverflow(x);

        if (rightOverflow > 0) {
          leftOverflow = getLeftOverflow(placeLeftX);

          if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
            x = placeLeftX;
            computedDirection = 'left';
          }
        }
      }
    }

    if (position === 'auto') x = confineHorizontally(x);
    var arrowY = arrow ? placeArrowY(y, anchorRect, containerRect, menuRect) : undefined;
    return {
      arrowY: arrowY,
      x: x,
      y: y,
      computedDirection: computedDirection
    };
  }, [placeArrowY, arrow, direction, position]);
  var placeToporBottom = useCallback(function (_ref9, _ref10, _ref11) {
    var anchorRect = _ref9.anchorRect,
        containerRect = _ref9.containerRect,
        menuRect = _ref9.menuRect;
    var placeToporBottomX = _ref10.placeToporBottomX,
        placeTopY = _ref10.placeTopY,
        placeBottomY = _ref10.placeBottomY;
    var getTopOverflow = _ref11.getTopOverflow,
        getBottomOverflow = _ref11.getBottomOverflow,
        confineHorizontally = _ref11.confineHorizontally,
        confineVertically = _ref11.confineVertically;
    var computedDirection = direction === 'top' ? 'top' : 'bottom';
    var x = placeToporBottomX;

    if (position !== 'initial') {
      x = confineHorizontally(x);

      if (position === 'anchor') {
        x = Math.min(x, anchorRect.right - containerRect.left);
        x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
      }
    }

    var y, topOverflow, bottomOverflow;

    if (computedDirection === 'top') {
      y = placeTopY;

      if (position !== 'initial') {
        topOverflow = getTopOverflow(y);

        if (topOverflow < 0) {
          bottomOverflow = getBottomOverflow(placeBottomY);

          if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
            y = placeBottomY;
            computedDirection = 'bottom';
          }
        }
      }
    } else {
      y = placeBottomY;

      if (position !== 'initial') {
        bottomOverflow = getBottomOverflow(y);

        if (bottomOverflow > 0) {
          topOverflow = getTopOverflow(placeTopY);

          if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
            y = placeTopY;
            computedDirection = 'top';
          }
        }
      }
    }

    if (position === 'auto') y = confineVertically(y);
    var arrowX = arrow ? placeArrowX(x, anchorRect, containerRect, menuRect) : undefined;
    return {
      arrowX: arrowX,
      x: x,
      y: y,
      computedDirection: computedDirection
    };
  }, [placeArrowX, arrow, direction, position]);
  var positionMenu = useCallback(function (positionHelpers, anchorRef) {
    var menuRect = positionHelpers.menuRect,
        containerRect = positionHelpers.containerRect,
        helpers = _objectWithoutProperties(positionHelpers, ["menuRect", "containerRect"]);

    var horizontalOffset = offsetX;
    var verticalOffset = offsetY;

    if (arrow) {
      if (direction === 'left' || direction === 'right') {
        horizontalOffset += arrowRef.current.offsetWidth;
      } else {
        verticalOffset += arrowRef.current.offsetHeight;
      }
    }

    var anchorRect = anchorRef.current.getBoundingClientRect();
    var placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    var placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    var placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    var placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    var placeToporBottomX, placeLeftorRightY;

    if (align === 'end') {
      placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
      placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === 'center') {
      placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
      placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
      placeToporBottomX = anchorRect.left - containerRect.left;
      placeLeftorRightY = anchorRect.top - containerRect.top;
    }

    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    var rects = {
      anchorRect: anchorRect,
      containerRect: containerRect,
      menuRect: menuRect
    };
    var placements = {
      placeLeftX: placeLeftX,
      placeRightX: placeRightX,
      placeLeftorRightY: placeLeftorRightY,
      placeTopY: placeTopY,
      placeBottomY: placeBottomY,
      placeToporBottomX: placeToporBottomX
    };

    switch (direction) {
      case 'left':
      case 'right':
        return placeLeftorRight(rects, placements, helpers);

      case 'top':
      case 'bottom':
      default:
        return placeToporBottom(rects, placements, helpers);
    }
  }, [arrow, align, direction, offsetX, offsetY, placeLeftorRight, placeToporBottom]);
  var positionContextMenu = useCallback(function (positionHelpers, anchorPoint) {
    var menuRect = positionHelpers.menuRect,
        containerRect = positionHelpers.containerRect,
        getLeftOverflow = positionHelpers.getLeftOverflow,
        getRightOverflow = positionHelpers.getRightOverflow,
        getTopOverflow = positionHelpers.getTopOverflow,
        getBottomOverflow = positionHelpers.getBottomOverflow,
        confineHorizontally = positionHelpers.confineHorizontally,
        confineVertically = positionHelpers.confineVertically;
    var x, y;
    x = anchorPoint.x - containerRect.left;
    y = anchorPoint.y - containerRect.top;
    var rightOverflow = getRightOverflow(x);

    if (rightOverflow > 0) {
      var adjustedX = x - menuRect.width;
      var leftOverflow = getLeftOverflow(adjustedX);

      if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
        x = adjustedX;
      }

      x = confineHorizontally(x);
    }

    var computedDirection = 'bottom';
    var bottomOverflow = getBottomOverflow(y);

    if (bottomOverflow > 0) {
      var adjustedY = y - menuRect.height;
      var topOverflow = getTopOverflow(adjustedY);

      if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
        y = adjustedY;
        computedDirection = 'top';
      }

      y = confineVertically(y);
    }

    return {
      x: x,
      y: y,
      computedDirection: computedDirection
    };
  }, []);
  var handlePosition = useCallback(function () {
    if (!containerRef.current) {
      if (!isProd) throw new Error('[react-menu] Menu cannot be positioned properly as container ref is null. If you initialise isOpen prop to true for ControlledMenu, please see this link for a solution: https://github.com/szhsin/react-menu/issues/2#issuecomment-719166062');
      return;
    }

    if (!scrollingRef.current) {
      scrollingRef.current = boundingBoxRef ? boundingBoxRef.current : getScrollAncestor(rootMenuRef.current);
    }

    var helpers = positionHelpers();
    var menuRect = helpers.menuRect;
    var results = {
      computedDirection: 'bottom'
    };

    if (anchorPoint) {
      results = positionContextMenu(helpers, anchorPoint);
    } else if (anchorRef) {
      results = positionMenu(helpers, anchorRef);
    }

    var _results = results,
        arrowX = _results.arrowX,
        arrowY = _results.arrowY,
        x = _results.x,
        y = _results.y,
        computedDirection = _results.computedDirection;
    var menuHeight = menuRect.height;

    if (overflow !== 'visible') {
      var getTopOverflow = helpers.getTopOverflow,
          getBottomOverflow = helpers.getBottomOverflow;

      var height, _overflowAmt;

      var prevHeight = latestMenuSize.current.height;
      var bottomOverflow = getBottomOverflow(y);

      if (bottomOverflow > 0 || floatEqual(bottomOverflow, 0) && floatEqual(menuHeight, prevHeight)) {
        height = menuHeight - bottomOverflow;
        _overflowAmt = bottomOverflow;
      } else {
        var topOverflow = getTopOverflow(y);

        if (topOverflow < 0 || floatEqual(topOverflow, 0) && floatEqual(menuHeight, prevHeight)) {
          height = menuHeight + topOverflow;
          _overflowAmt = 0 - topOverflow;
          if (height >= 0) y -= topOverflow;
        }
      }

      if (height >= 0) {
        menuHeight = height;
        setOverflowData({
          height: height,
          overflowAmt: _overflowAmt
        });
      } else {
        setOverflowData();
      }
    }

    if (arrow) setArrowPosition({
      x: arrowX,
      y: arrowY
    });
    setMenuPosition({
      x: x,
      y: y
    });
    setExpandedDirection(computedDirection);
    latestMenuSize.current = {
      width: menuRect.width,
      height: menuHeight
    };
  }, [arrow, anchorPoint, anchorRef, containerRef, boundingBoxRef, rootMenuRef, scrollingRef, overflow, positionHelpers, positionMenu, positionContextMenu]);
  useIsomorphicLayoutEffect(function () {
    if (isOpen) {
      handlePosition();
      if (latestOpen.current) forceReposSubmenu();
    }

    latestHandlePosition.current = handlePosition;
  }, [isOpen, handlePosition, reposFlag]);
  useIsomorphicLayoutEffect(function () {
    if (overflowData && !descendOverflowRef.current) menuRef.current.scrollTop = 0;
  }, [overflowData]);
  useIsomorphicLayoutEffect(function () {
    if (animation) {
      if (isOpen) {
        setClosing(false);
      } else if (isOpen !== latestOpen.current) {
        setClosing(true);
      }
    }

    latestOpen.current = isOpen;
  }, [animation, isOpen]);
  useEffect(function () {
    if (!isOpen) return;

    if (!anchorScrollingRef.current && rootAnchorRef && rootAnchorRef.current.tagName) {
      anchorScrollingRef.current = getScrollAncestor(rootAnchorRef.current);
    }

    var scrollCurrent = scrollingRef.current;
    var menuScroll = scrollCurrent && scrollCurrent.addEventListener ? scrollCurrent : window;
    var anchorScroll = anchorScrollingRef.current || menuScroll;
    var scroll = viewScroll;
    if (anchorScroll !== menuScroll && scroll === 'initial') scroll = 'auto';
    if (scroll === 'initial') return;
    if (scroll === 'auto' && overflow !== 'visible') scroll = 'close';

    var handleScroll = function handleScroll() {
      if (scroll === 'auto') {
        batchedUpdates(handlePosition);
      } else {
        safeCall(onClose, {
          reason: CloseReason.SCROLL
        });
      }
    };

    var scrollObservers = anchorScroll !== menuScroll && viewScroll !== 'initial' ? [anchorScroll, menuScroll] : [anchorScroll];
    scrollObservers.forEach(function (o) {
      return o.addEventListener('scroll', handleScroll);
    });
    return function () {
      return scrollObservers.forEach(function (o) {
        return o.removeEventListener('scroll', handleScroll);
      });
    };
  }, [rootAnchorRef, anchorScrollingRef, scrollingRef, isOpen, overflow, onClose, viewScroll, handlePosition]);
  useEffect(function () {
    if (typeof ResizeObserver !== 'function' || reposition === 'initial') return;
    var resizeObserver = new ResizeObserver(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 1),
          entry = _ref13[0];

      var borderBoxSize = entry.borderBoxSize,
          target = entry.target;
      var width, height;

      if (borderBoxSize) {
        var _ref14 = borderBoxSize[0] || borderBoxSize,
            inlineSize = _ref14.inlineSize,
            blockSize = _ref14.blockSize;

        width = inlineSize;
        height = blockSize;
      } else {
        var borderRect = target.getBoundingClientRect();
        width = borderRect.width;
        height = borderRect.height;
      }

      if (width === 0 || height === 0) return;
      if (floatEqual(width, latestMenuSize.current.width, 1) && floatEqual(height, latestMenuSize.current.height, 1)) return;
      batchedUpdates(function () {
        latestHandlePosition.current();
        forceReposSubmenu();
      });
    });
    var observeTarget = menuRef.current;
    resizeObserver.observe(observeTarget, {
      box: 'border-box'
    });
    return function () {
      return resizeObserver.unobserve(observeTarget);
    };
  }, [reposition]);
  useEffect(function () {
    if (!isOpen) {
      dispatch({
        type: HoverIndexActionTypes.RESET
      });
      if (!animation) setOverflowData();
    }

    var id = setTimeout(function () {
      if (!isOpen || !menuRef.current || menuRef.current.contains(document.activeElement)) return;
      if (captureFocus) menuRef.current.focus();

      if (menuItemFocus.position === FocusPositions.FIRST) {
        dispatch({
          type: HoverIndexActionTypes.FIRST
        });
      } else if (menuItemFocus.position === FocusPositions.LAST) {
        dispatch({
          type: HoverIndexActionTypes.LAST
        });
      }
    }, animation ? 170 : 100);
    return function () {
      return clearTimeout(id);
    };
  }, [animation, captureFocus, isOpen, menuItemFocus]);
  var isSubmenuOpen = openSubmenuCount > 0;
  var itemContext = useMemo(function () {
    return {
      isParentOpen: isOpen,
      hoverIndex: hoverIndex,
      isSubmenuOpen: isSubmenuOpen,
      dispatch: dispatch
    };
  }, [isOpen, hoverIndex, isSubmenuOpen]);
  var maxHeight, overflowAmt;

  if (overflowData) {
    descendOverflowRef.current ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
  }

  var listContext = useMemo(function () {
    return {
      reposSubmenu: reposSubmenu,
      overflow: overflow,
      overflowAmt: overflowAmt
    };
  }, [reposSubmenu, overflow, overflowAmt]);
  var overflowStyles = maxHeight >= 0 ? {
    maxHeight: maxHeight,
    overflow: overflow
  } : undefined;
  var modifiers = {
    open: isOpen,
    closing: isClosing,
    animation: animation,
    dir: animation && expandedDirection
  };
  var userModifiers = Object.freeze(_objectSpread(_objectSpread({}, modifiers), {}, {
    dir: expandedDirection
  }));
  var arrowModifiers = Object.freeze({
    dir: expandedDirection
  });
  var handlers = attachHandlerProps({
    onKeyDown: handleKeyDown,
    onAnimationEnd: handleAnimationEnd
  }, restProps);
  return /*#__PURE__*/React.createElement("ul", Object.assign({
    role: "menu",
    tabIndex: "-1",
    "aria-disabled": isDisabled || undefined,
    "aria-label": ariaLabel
  }, restProps, handlers, {
    ref: menuRef,
    className: bem(menuClass, null, modifiers)(className, userModifiers),
    style: _objectSpread(_objectSpread(_objectSpread({}, flatStyles(styles, userModifiers)), overflowStyles), {}, {
      left: "".concat(menuPosition.x, "px"),
      top: "".concat(menuPosition.y, "px")
    })
  }), arrow && /*#__PURE__*/React.createElement("div", {
    className: bem(menuClass, menuArrowClass, arrowModifiers)(arrowClassName),
    style: _objectSpread(_objectSpread({}, flatStyles(arrowStyles, arrowModifiers)), {}, {
      left: arrowPosition.x && "".concat(arrowPosition.x, "px"),
      top: arrowPosition.y && "".concat(arrowPosition.y, "px")
    }),
    ref: arrowRef
  }), /*#__PURE__*/React.createElement(MenuListContext.Provider, {
    value: listContext
  }, /*#__PURE__*/React.createElement(MenuListItemContext.Provider, {
    value: itemContext
  }, menuItems)));
}), 'MenuList');

function submenuCountReducer(state, _ref15) {
  var type = _ref15.type;

  switch (type) {
    case SubmenuActionTypes.OPEN:
      return state + 1;

    case SubmenuActionTypes.CLOSE:
      return Math.max(state - 1, 0);

    default:
      return state;
  }
}

var useMenuList = function useMenuList(menuListProps, _ref16) {
  var id = _ref16.id,
      animation = _ref16.animation,
      boundingBoxRef = _ref16.boundingBoxRef,
      boundingBoxPadding = _ref16.boundingBoxPadding,
      debugging = _ref16.debugging,
      reposition = _ref16.reposition,
      submenuOpenDelay = _ref16.submenuOpenDelay,
      submenuCloseDelay = _ref16.submenuCloseDelay,
      viewScroll = _ref16.viewScroll,
      portal = _ref16.portal,
      theming = _ref16.theming,
      isMounted = _ref16.isMounted,
      onClick = _ref16.onClick,
      onClose = _ref16.onClose,
      skipClick = _ref16.skipClick;
  var containerRef = useRef(null);
  var scrollingRef = useRef(null);
  var anchorScrollingRef = useRef(null);
  var anchorRef = menuListProps.anchorRef,
      isOpen = menuListProps.isOpen;
  var settings = useMemo(function () {
    return {
      animation: animation,
      boundingBoxRef: boundingBoxRef,
      boundingBoxPadding: boundingBoxPadding,
      rootMenuRef: containerRef,
      rootAnchorRef: anchorRef,
      scrollingRef: scrollingRef,
      anchorScrollingRef: anchorScrollingRef,
      reposition: reposition,
      viewScroll: viewScroll
    };
  }, [animation, anchorRef, boundingBoxRef, boundingBoxPadding, reposition, viewScroll]);
  var itemSettings = useMemo(function () {
    return {
      debugging: debugging,
      submenuOpenDelay: submenuOpenDelay,
      submenuCloseDelay: submenuCloseDelay
    };
  }, [debugging, submenuOpenDelay, submenuCloseDelay]);
  var eventHandlers = useMemo(function () {
    return {
      handleClick: function handleClick(event, isStopPropagation, isCheckorRadio) {
        if (!isStopPropagation) safeCall(onClick, event);
        var keepOpen = event.keepOpen;

        if (keepOpen === undefined) {
          keepOpen = isCheckorRadio && event.key === Keys.SPACE;
        }

        if (!keepOpen) {
          safeCall(onClose, {
            value: event.value,
            key: event.key,
            reason: CloseReason.CLICK
          });
        }
      },
      handleClose: function handleClose(key) {
        safeCall(onClose, {
          key: key,
          reason: CloseReason.CLICK
        });
      }
    };
  }, [onClick, onClose]);

  var handleKeyDown = function handleKeyDown(_ref17) {
    var key = _ref17.key;

    switch (key) {
      case Keys.ESC:
        safeCall(onClose, {
          key: key,
          reason: CloseReason.CANCEL
        });
        break;
    }
  };

  var handleBlur = function handleBlur(e) {
    if (isOpen && !e.currentTarget.contains(e.relatedTarget || document.activeElement) && !debugging) {
      safeCall(onClose, {
        reason: CloseReason.BLUR
      });

      if (skipClick) {
        skipClick.current = true;
        setTimeout(function () {
          return skipClick.current = false;
        }, 300);
      }
    }
  };

  var menuList = /*#__PURE__*/React.createElement("div", {
    id: id,
    className: bem(menuContainerClass, null, {
      theme: theming
    })(),
    ref: containerRef,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  }, isMounted && /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: settings
  }, /*#__PURE__*/React.createElement(ItemSettingsContext.Provider, {
    value: itemSettings
  }, /*#__PURE__*/React.createElement(EventHandlersContext.Provider, {
    value: eventHandlers
  }, /*#__PURE__*/React.createElement(MenuList, Object.assign({}, menuListProps, {
    containerRef: containerRef,
    onClose: onClose
  }))))));

  if (portal) {
    return /*#__PURE__*/ReactDOM.createPortal(menuList, document.body);
  } else {
    return menuList;
  }
};

var Menu = /*#__PURE__*/React.memo(function Menu(_ref18) {
  var ariaLabel = _ref18['aria-label'],
      id = _ref18.id,
      animation = _ref18.animation,
      boundingBoxRef = _ref18.boundingBoxRef,
      boundingBoxPadding = _ref18.boundingBoxPadding,
      _ = _ref18.captureFocus,
      debugging = _ref18.debugging,
      reposition = _ref18.reposition,
      viewScroll = _ref18.viewScroll,
      keepMounted = _ref18.keepMounted,
      menuButton = _ref18.menuButton,
      portal = _ref18.portal,
      submenuOpenDelay = _ref18.submenuOpenDelay,
      submenuCloseDelay = _ref18.submenuCloseDelay,
      theming = _ref18.theming,
      onClick = _ref18.onClick,
      onChange = _ref18.onChange,
      restProps = _objectWithoutProperties(_ref18, ["aria-label", "id", "animation", "boundingBoxRef", "boundingBoxPadding", "captureFocus", "debugging", "reposition", "viewScroll", "keepMounted", "menuButton", "portal", "submenuOpenDelay", "submenuCloseDelay", "theming", "onClick", "onChange"]);

  var _useMenuState = useMenuState(keepMounted),
      isMounted = _useMenuState.isMounted,
      isOpen = _useMenuState.isOpen,
      menuItemFocus = _useMenuState.menuItemFocus,
      openMenu = _useMenuState.openMenu,
      closeMenu = _useMenuState.closeMenu;

  var skipClick = useRef(false);
  var buttonRef = useRef(null);
  var button = safeCall(menuButton, {
    open: isOpen
  });
  if (!button) throw new Error('Menu requires a menuButton prop.');
  var handleClose = useCallback(function (e) {
    closeMenu();
    if (e.key) buttonRef.current.focus();
  }, [closeMenu]);
  var handleClick = useCallback(function (e) {
    if (skipClick.current) return;
    openMenu(e.detail === 0 ? FocusPositions.FIRST : FocusPositions.INITIAL);
  }, [openMenu]);
  var handleKeyDown = useCallback(function (e) {
    var handled = false;

    switch (e.key) {
      case Keys.UP:
        openMenu(FocusPositions.LAST);
        handled = true;
        break;

      case Keys.DOWN:
        openMenu(FocusPositions.FIRST);
        handled = true;
        break;
    }

    if (handled) e.preventDefault();
  }, [openMenu]);
  var renderButton = useMemo(function () {
    var buttonProps = _objectSpread({
      ref: buttonRef
    }, attachHandlerProps({
      onClick: handleClick,
      onKeyDown: handleKeyDown
    }, button.props));

    if (getName(button.type) === 'MenuButton') {
      buttonProps.isOpen = isOpen;
    }

    return /*#__PURE__*/React.cloneElement(button, buttonProps);
  }, [button, isOpen, handleClick, handleKeyDown]);
  var menuList = useMenuList(_objectSpread(_objectSpread({}, restProps), {}, {
    ariaLabel: ariaLabel || (typeof button.props.children === 'string' ? button.props.children : 'Menu'),
    anchorRef: buttonRef,
    isOpen: isOpen,
    menuItemFocus: menuItemFocus
  }), {
    id: id,
    animation: animation,
    boundingBoxRef: boundingBoxRef,
    boundingBoxPadding: boundingBoxPadding,
    debugging: debugging,
    reposition: reposition,
    submenuOpenDelay: submenuOpenDelay,
    submenuCloseDelay: submenuCloseDelay,
    viewScroll: viewScroll,
    portal: portal,
    theming: theming,
    isMounted: isMounted,
    onClick: onClick,
    onClose: handleClose,
    skipClick: skipClick
  });
  useMenuChange(onChange, isOpen);
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderButton, menuList);
});
Menu.defaultProps = _objectSpread(_objectSpread({}, menuDefaultPropsBase), {}, {
  keepMounted: true
});
var ControlledMenu = /*#__PURE__*/React.memo(function ControlledMenu(_ref19) {
  var ariaLabel = _ref19['aria-label'],
      id = _ref19.id,
      animation = _ref19.animation,
      boundingBoxRef = _ref19.boundingBoxRef,
      boundingBoxPadding = _ref19.boundingBoxPadding,
      debugging = _ref19.debugging,
      reposition = _ref19.reposition,
      submenuOpenDelay = _ref19.submenuOpenDelay,
      submenuCloseDelay = _ref19.submenuCloseDelay,
      viewScroll = _ref19.viewScroll,
      portal = _ref19.portal,
      theming = _ref19.theming,
      isMounted = _ref19.isMounted,
      onClick = _ref19.onClick,
      onClose = _ref19.onClose,
      restProps = _objectWithoutProperties(_ref19, ["aria-label", "id", "animation", "boundingBoxRef", "boundingBoxPadding", "debugging", "reposition", "submenuOpenDelay", "submenuCloseDelay", "viewScroll", "portal", "theming", "isMounted", "onClick", "onClose"]);

  return useMenuList(_objectSpread(_objectSpread({}, restProps), {}, {
    ariaLabel: ariaLabel || 'Menu'
  }), {
    id: id,
    animation: animation,
    boundingBoxRef: boundingBoxRef,
    boundingBoxPadding: boundingBoxPadding,
    debugging: debugging,
    reposition: reposition,
    submenuOpenDelay: submenuOpenDelay,
    submenuCloseDelay: submenuCloseDelay,
    viewScroll: viewScroll,
    portal: portal,
    theming: theming,
    isMounted: isMounted,
    onClick: onClick,
    onClose: onClose
  });
});
ControlledMenu.defaultProps = _objectSpread(_objectSpread({}, menuDefaultPropsBase), {}, {
  captureFocus: true,
  isOpen: false,
  isMounted: true,
  menuItemFocus: {
    position: FocusPositions.INITIAL
  }
});
var SubMenu = defineName( /*#__PURE__*/React.memo(function SubMenu(_ref20) {
  var ariaLabel = _ref20['aria-label'],
      itemClassName = _ref20.itemClassName,
      itemStyles = _ref20.itemStyles,
      disabled = _ref20.disabled,
      keepMounted = _ref20.keepMounted,
      label = _ref20.label,
      index = _ref20.index,
      onChange = _ref20.onChange,
      _1 = _ref20.captureFocus,
      _2 = _ref20.repositionFlag,
      restProps = _objectWithoutProperties(_ref20, ["aria-label", "itemClassName", "itemStyles", "disabled", "keepMounted", "label", "index", "onChange", "captureFocus", "repositionFlag"]);

  var _useMenuState2 = useMenuState(keepMounted),
      isMounted = _useMenuState2.isMounted,
      isOpen = _useMenuState2.isOpen,
      menuItemFocus = _useMenuState2.menuItemFocus,
      openMenu = _useMenuState2.openMenu,
      closeMenu = _useMenuState2.closeMenu;

  var _useContext4 = useContext(MenuListItemContext),
      isParentOpen = _useContext4.isParentOpen,
      hoverIndex = _useContext4.hoverIndex,
      isSubmenuOpen = _useContext4.isSubmenuOpen,
      dispatch = _useContext4.dispatch;

  var _useContext5 = useContext(ItemSettingsContext),
      debugging = _useContext5.debugging,
      submenuOpenDelay = _useContext5.submenuOpenDelay,
      submenuCloseDelay = _useContext5.submenuCloseDelay;

  var isHovering = hoverIndex === index;
  var isDisabled = Boolean(disabled);

  var _useActiveState = useActiveState(isHovering, isDisabled, Keys.RIGHT),
      isActive = _useActiveState.isActive,
      onKeyUp = _useActiveState.onKeyUp,
      activeStateHandlers = _objectWithoutProperties(_useActiveState, ["isActive", "onKeyUp"]);

  var containerRef = useRef(null);
  var itemRef = useRef(null);
  var timeoutId = useRef();
  var handleClose = useCallback(function () {
    closeMenu();
    itemRef.current.focus();
  }, [closeMenu]);

  var delayOpen = function delayOpen(delay) {
    dispatch({
      type: HoverIndexActionTypes.SET,
      index: index
    });
    timeoutId.current = setTimeout(openMenu, Math.max(delay, 0));
  };

  var handleMouseEnter = function handleMouseEnter() {
    if (isDisabled || isOpen) return;

    if (isSubmenuOpen) {
      timeoutId.current = setTimeout(function () {
        return delayOpen(submenuOpenDelay - submenuCloseDelay);
      }, submenuCloseDelay);
    } else {
      delayOpen(submenuOpenDelay);
    }
  };

  var handleMouseLeave = function handleMouseLeave() {
    clearTimeout(timeoutId.current);

    if (!isOpen) {
      dispatch({
        type: HoverIndexActionTypes.UNSET,
        index: index
      });
    }
  };

  var handleClick = function handleClick() {
    if (isDisabled) return;
    clearTimeout(timeoutId.current);
    openMenu();
  };

  var handleKeyDown = function handleKeyDown(e) {
    var handled = false;

    switch (e.key) {
      case Keys.LEFT:
        if (isOpen) {
          handleClose();
          handled = true;
        }

        break;

      case Keys.RIGHT:
        if (!isOpen) handled = true;
        break;
    }

    if (handled) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (!isActive) return;
    onKeyUp(e);

    switch (e.key) {
      case Keys.SPACE:
      case Keys.ENTER:
      case Keys.RIGHT:
        openMenu(FocusPositions.FIRST);
        break;
    }
  };

  var handleBlur = function handleBlur(e) {
    if (debugging) return;
    var relatedTarget = e.relatedTarget || document.activeElement;

    if (!e.currentTarget.contains(relatedTarget)) {
      closeMenu();
      dispatch({
        type: HoverIndexActionTypes.UNSET,
        index: index
      });
    }
  };

  useEffect(function () {
    return function () {
      return clearTimeout(timeoutId.current);
    };
  }, []);
  useEffect(function () {
    if (isHovering && isParentOpen) {
      itemRef.current.focus();
    } else {
      closeMenu();
    }
  }, [isHovering, isParentOpen, closeMenu]);
  useEffect(function () {
    dispatch({
      type: isOpen ? SubmenuActionTypes.OPEN : SubmenuActionTypes.CLOSE
    });
  }, [dispatch, isOpen]);
  useMenuChange(onChange, isOpen);
  var modifiers = Object.freeze({
    open: isOpen,
    hover: isHovering,
    active: isActive,
    disabled: isDisabled
  });
  return /*#__PURE__*/React.createElement("li", {
    className: bem(menuClass, subMenuClass)(),
    role: "presentation",
    ref: containerRef,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement("div", Object.assign({
    className: bem(menuClass, menuItemClass, modifiers)(itemClassName),
    style: flatStyles(itemStyles, modifiers),
    role: "menuitem",
    "aria-haspopup": "true",
    "aria-expanded": isOpen,
    "aria-disabled": isDisabled || undefined,
    tabIndex: isHovering && !isOpen ? 0 : -1,
    ref: itemRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onMouseDown: function onMouseDown() {
      return !isHovering && dispatch({
        type: HoverIndexActionTypes.SET,
        index: index
      });
    },
    onClick: handleClick,
    onKeyUp: handleKeyUp
  }, activeStateHandlers), safeCall(label, modifiers)), isMounted && /*#__PURE__*/React.createElement(MenuList, Object.assign({}, restProps, {
    ariaLabel: ariaLabel || (typeof label === 'string' ? label : 'Submenu'),
    anchorRef: itemRef,
    containerRef: containerRef,
    isOpen: isOpen,
    isDisabled: isDisabled,
    menuItemFocus: menuItemFocus
  })));
}), 'SubMenu');
SubMenu.defaultProps = _objectSpread(_objectSpread({}, sharedMenuDefaultProp), {}, {
  direction: 'right',
  keepMounted: true
});
var MenuItem = defineName( /*#__PURE__*/React.memo(function MenuItem(_ref21) {
  var className = _ref21.className,
      styles = _ref21.styles,
      value = _ref21.value,
      href = _ref21.href,
      type = _ref21.type,
      checked = _ref21.checked,
      disabled = _ref21.disabled,
      index = _ref21.index,
      children = _ref21.children,
      onClick = _ref21.onClick,
      restProps = _objectWithoutProperties(_ref21, ["className", "styles", "value", "href", "type", "checked", "disabled", "index", "children", "onClick"]);

  var isDisabled = Boolean(disabled);

  var _useItemState = useItemState(isDisabled, index),
      ref = _useItemState.ref,
      isHovering = _useItemState.isHovering,
      setHover = _useItemState.setHover,
      onBlur = _useItemState.onBlur,
      onMouseEnter = _useItemState.onMouseEnter,
      onMouseLeave = _useItemState.onMouseLeave;

  var eventHandlers = useContext(EventHandlersContext);
  var radioGroup = useContext(RadioGroupContext);

  var _useActiveState2 = useActiveState(isHovering, isDisabled),
      isActive = _useActiveState2.isActive,
      onKeyUp = _useActiveState2.onKeyUp,
      activeStateBlur = _useActiveState2.onBlur,
      activeStateHandlers = _objectWithoutProperties(_useActiveState2, ["isActive", "onKeyUp", "onBlur"]);

  var isRadio = type === 'radio';
  var isCheckBox = type === 'checkbox';
  var isAnchor = Boolean(href) && !isDisabled && !isRadio && !isCheckBox;
  var isChecked = isRadio ? radioGroup.value === value : isCheckBox ? Boolean(checked) : false;

  var handleClick = function handleClick(key) {
    if (isDisabled) return;
    var isStopPropagation = false;
    var event = {
      value: value,
      key: key
    };

    if (isRadio) {
      event.name = radioGroup.name;
      safeCall(radioGroup.onChange, event);
    }

    event.checked = isCheckBox ? !isChecked : false;
    isStopPropagation = safeCall(onClick, event) === false;
    eventHandlers.handleClick(event, isStopPropagation, isCheckBox || isRadio);
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (!isActive) return;
    onKeyUp(e);

    switch (e.key) {
      case Keys.SPACE:
      case Keys.ENTER:
        if (isAnchor) {
          ref.current.click();
        } else {
          handleClick(e.key);
        }

        break;
    }
  };

  var handleBlur = function handleBlur(e) {
    activeStateBlur(e);
    onBlur(e);
  };

  var modifiers = Object.freeze({
    type: type,
    disabled: isDisabled,
    hover: isHovering,
    active: isActive,
    checked: isChecked,
    anchor: isAnchor
  });
  var handlers = attachHandlerProps(_objectSpread(_objectSpread({}, activeStateHandlers), {}, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: setHover,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    onClick: function onClick() {
      return handleClick();
    }
  }), restProps);

  var menuItemProps = _objectSpread(_objectSpread(_objectSpread({
    role: isRadio ? 'menuitemradio' : isCheckBox ? 'menuitemcheckbox' : 'menuitem',
    'aria-checked': isRadio || isCheckBox ? isChecked : undefined,
    'aria-disabled': isDisabled || undefined,
    tabIndex: isHovering ? 0 : -1
  }, restProps), handlers), {}, {
    ref: ref,
    className: bem(menuClass, menuItemClass, modifiers)(className),
    style: flatStyles(styles, modifiers)
  });

  var renderChildren = safeCall(children, modifiers);

  if (isAnchor) {
    return /*#__PURE__*/React.createElement("li", {
      role: "presentation"
    }, /*#__PURE__*/React.createElement("a", Object.assign({}, menuItemProps, {
      href: href
    }), renderChildren));
  } else {
    return /*#__PURE__*/React.createElement("li", menuItemProps, renderChildren);
  }
}), 'MenuItem');
var FocusableItem = defineName( /*#__PURE__*/React.memo(function FocusableItem(_ref22) {
  var className = _ref22.className,
      styles = _ref22.styles,
      disabled = _ref22.disabled,
      index = _ref22.index,
      children = _ref22.children,
      restProps = _objectWithoutProperties(_ref22, ["className", "styles", "disabled", "index", "children"]);

  var isDisabled = Boolean(disabled);

  var _useItemState2 = useItemState(isDisabled, index),
      ref = _useItemState2.ref,
      isHovering = _useItemState2.isHovering,
      setHover = _useItemState2.setHover,
      onBlur = _useItemState2.onBlur,
      onMouseEnter = _useItemState2.onMouseEnter,
      _onMouseLeave = _useItemState2.onMouseLeave;

  var _useContext6 = useContext(EventHandlersContext),
      handleClose = _useContext6.handleClose;

  var baseParams = {
    disabled: isDisabled,
    hover: isHovering
  };
  var modifiers = Object.freeze(_objectSpread(_objectSpread({}, baseParams), {}, {
    focusable: true
  }));
  var renderChildren = safeCall(children, _objectSpread(_objectSpread({}, baseParams), {}, {
    ref: ref,
    closeMenu: handleClose
  }));
  var handlers = attachHandlerProps({
    onMouseEnter: onMouseEnter,
    onMouseLeave: function onMouseLeave(e) {
      return _onMouseLeave(e, true);
    },
    onFocus: setHover,
    onBlur: onBlur
  }, restProps);
  return /*#__PURE__*/React.createElement("li", Object.assign({
    "aria-disabled": isDisabled || undefined,
    role: "menuitem",
    tabIndex: "-1"
  }, restProps, handlers, {
    className: bem(menuClass, menuItemClass, modifiers)(className),
    style: flatStyles(styles, modifiers)
  }), renderChildren);
}), 'FocusableItem');
var MenuDivider = defineName( /*#__PURE__*/React.memo(function MenuDivider(_ref23) {
  var className = _ref23.className,
      styles = _ref23.styles,
      restProps = _objectWithoutProperties(_ref23, ["className", "styles"]);

  return /*#__PURE__*/React.createElement("li", Object.assign({
    role: "separator"
  }, restProps, {
    className: bem(menuClass, menuDividerClass)(className),
    style: flatStyles(styles)
  }));
}), 'MenuDivider');
var MenuHeader = defineName( /*#__PURE__*/React.memo(function MenuHeader(_ref24) {
  var className = _ref24.className,
      styles = _ref24.styles,
      restProps = _objectWithoutProperties(_ref24, ["className", "styles"]);

  return /*#__PURE__*/React.createElement("li", Object.assign({
    role: "presentation"
  }, restProps, {
    className: bem(menuClass, menuHeaderClass)(className),
    style: flatStyles(styles)
  }));
}), 'MenuHeader');
var MenuGroup = defineName( /*#__PURE__*/React.memo(function MenuGroup(_ref25) {
  var className = _ref25.className,
      styles = _ref25.styles,
      takeOverflow = _ref25.takeOverflow,
      restProps = _objectWithoutProperties(_ref25, ["className", "styles", "takeOverflow"]);

  var ref = useRef(null);

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      overflowStyles = _useState16[0],
      setOverflowStyles = _useState16[1];

  var _useContext7 = useContext(MenuListContext),
      overflow = _useContext7.overflow,
      overflowAmt = _useContext7.overflowAmt;

  useIsomorphicLayoutEffect(function () {
    var maxHeight;

    if (takeOverflow && overflowAmt >= 0) {
      maxHeight = ref.current.getBoundingClientRect().height - overflowAmt;
      if (maxHeight < 0) maxHeight = 0;
    }

    setOverflowStyles(maxHeight >= 0 ? {
      maxHeight: maxHeight,
      overflow: overflow
    } : undefined);
  }, [takeOverflow, overflow, overflowAmt]);
  useIsomorphicLayoutEffect(function () {
    if (overflowStyles) ref.current.scrollTop = 0;
  }, [overflowStyles]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: ref
  }, restProps, {
    className: bem(menuClass, menuGroupClass)(className),
    style: _objectSpread(_objectSpread({}, flatStyles(styles)), overflowStyles)
  }));
}), 'MenuGroup');
var MenuRadioGroup = defineName( /*#__PURE__*/React.memo(function MenuRadioGroup(_ref26) {
  var ariaLabel = _ref26['aria-label'],
      className = _ref26.className,
      styles = _ref26.styles,
      name = _ref26.name,
      value = _ref26.value,
      children = _ref26.children,
      onChange = _ref26.onChange,
      restProps = _objectWithoutProperties(_ref26, ["aria-label", "className", "styles", "name", "value", "children", "onChange"]);

  var contextValue = useMemo(function () {
    return {
      name: name,
      value: value,
      onChange: onChange
    };
  }, [name, value, onChange]);
  return /*#__PURE__*/React.createElement("li", {
    role: "presentation"
  }, /*#__PURE__*/React.createElement("ul", Object.assign({
    role: "group",
    "aria-label": ariaLabel || name || 'Radio group'
  }, restProps, {
    className: bem(menuClass, radioGroupClass)(className),
    style: flatStyles(styles)
  }), /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: contextValue
  }, children)));
}), 'MenuRadioGroup');
export { ControlledMenu, FocusableItem, Menu, MenuButton, MenuDivider, MenuGroup, MenuHeader, MenuItem, MenuRadioGroup, SubMenu, applyHOC, applyStatics, useMenuState };